import React from 'react';

/**
 * 설정 섹션 컴포넌트
 */
function SettingsSection() {
  return (
    <section id="settings" className="guide-section">
      <h2>⚙️ 설정</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>🎨 테마 설정</h3>
          <div className="feature-steps">
            <ul>
              <li>☀️ 라이트 모드</li>
              <li>🌙 다크 모드</li>
              <li>🔄 시스템 따라가기 (자동)</li>
            </ul>
            <p>우상단 테마 토글 버튼으로 빠른 변경 가능</p>
          </div>
        </div>

        <div className="feature-card">
          <h3>♿ 접근성 옵션</h3>
          <div className="feature-steps">
            <ul>
              <li>🔍 고대비 모드</li>
              <li>📝 큰 폰트 크기</li>
              <li>⚡ 애니메이션 비활성화</li>
            </ul>
            
            <div className="tip-box">
              <strong>💡 접근성:</strong> 시각적 불편함이 있는 사용자를 위한 옵션입니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔐 보안 설정</h3>
          <div className="feature-steps">
            <ul>
              <li>⏰ 자동 로그아웃 시간 (15분, 30분, 1시간)</li>
              <li>📋 복사 알림 표시 여부</li>
              <li>🔒 비활성화 시 자동 잠금</li>
            </ul>
            
            <div className="warning-box">
              <strong>⚠️ 보안:</strong> 공용 컴퓨터에서는 짧은 자동 로그아웃 시간을 권장합니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>📊 데이터 관리</h3>
          <div className="feature-steps">
            <p><strong>내보내기:</strong></p>
            <ul>
              <li>📄 JSON 형식으로 데이터 백업</li>
              <li>🔐 암호화된 상태로 내보내기</li>
              <li>📅 자동 백업 스케줄 설정</li>
            </ul>
            
            <p><strong>데이터 삭제:</strong></p>
            <ul>
              <li>🗑️ 전체 데이터 완전 삭제</li>
              <li>⚠️ 삭제 후 복구 불가능</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SettingsSection;